import { AuthenticationService } from 'data/services';
import { AuthenticationServiceInterface } from 'domain/services';
import { makeRemoteAuthenticationChangePassword } from 'main/factories/usecases/Authentication/authentication-password-reset/authentication-change-password-factory';
import { makeRemoteAuthenticationSendPasswordResetCode } from 'main/factories/usecases/Authentication/authentication-password-reset/authentication-send-code-factory';
import { makeRemoteAuthenticationPasswordResetVerifyCode } from 'main/factories/usecases/Authentication/authentication-password-reset/authentication-verify-code';
import { makeRemoteAuthSignOut } from 'main/factories/usecases/Authentication/remote-auth-sign-out-factory';
import { makeRemoteSignInViaImpersonate } from 'main/factories/usecases/Authentication/remote-sign-in-via-impersonate-factory';
import { makeRemoteGetActiveSession } from 'main/factories/usecases/Authentication/session/get-active-session-factory';

export const makeAuthSignOutService = (): AuthenticationServiceInterface => {
  return new AuthenticationService(
    makeRemoteAuthSignOut(),
    makeRemoteGetActiveSession(),
    makeRemoteSignInViaImpersonate(),
    makeRemoteAuthenticationChangePassword(),
    makeRemoteAuthenticationSendPasswordResetCode(),
    makeRemoteAuthenticationPasswordResetVerifyCode(),
  );
};
